import type React from 'react';

import Box from '@mui/material/Box';
import classNames from 'classnames';

import {
  MOBILE_FAB_CLEARANCE,
  PAGE_WITH_MOBILE_FAB,
} from '../../../components/PageActionsButton/mobileFab';
import { Scrollbar } from '../../../components';

export interface PageContentProps {
  children: React.ReactNode;
  withPadding?: boolean;
  className?: string;
}
const PageContent = ({
  children,
  className,
  withPadding,
}: PageContentProps) => {
  return (
    <Scrollbar
      className={classNames(
        'flex flex-col grow-2 overflow-y-auto md:pb-0',
        {
          'sm:px-8 px-2': withPadding,
        },
        className,
      )}
    >
      {children}
      {/* The phone's floating "+" is fixed near the bottom edge, over whatever
          the page shows there: scrolled to the end, the page's last control (a
          pager's Next arrow, a last row's or card's menu) must sit above it,
          or a tap there opens the "+" instead. One spacer here covers every
          page, instead of each list reserving its own room. */}
      <Box
        sx={{
          display: 'none',
          flexShrink: 0,
          // only in the page that holds the button, not in a modal over it
          [`${PAGE_WITH_MOBILE_FAB} > .Mfw-Scrollbar > &`]: {
            display: 'block',
            height: MOBILE_FAB_CLEARANCE,
          },
        }}
        aria-hidden
      />
    </Scrollbar>
  );
};

export default PageContent;
